<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Labyrinth</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#chapter-one-mark-brooks">Chapter One Mark Brooks</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-two-the-problem">Chapter Two The Problem</a></li>
<li id="toc-li-6"><span href="#/text/ch006#chapter-three-do-the-right-thing" title="Link target outside of Sample">Chapter Three Do the Right Thing</span></li>
<li id="toc-li-7"><span href="#/text/ch007#chapter-four-the-envelope-and-the-key" title="Link target outside of Sample">Chapter Four The Envelope and the Key</span></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-five-the-locker" title="Link target outside of Sample">Chapter Five The Locker</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-six-mrs.-goldstein" title="Link target outside of Sample">Chapter Six Mrs. Goldstein</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-seven-price-and-artest" title="Link target outside of Sample">Chapter Seven Price and Artest</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-eight-raul" title="Link target outside of Sample">Chapter Eight Raul</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-nine-the-gates-begin-to-open" title="Link target outside of Sample">Chapter Nine The Gates Begin to Open</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-ten-fred-and-amir" title="Link target outside of Sample">Chapter Ten Fred and Amir</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-eleven-gotcha" title="Link target outside of Sample">Chapter Eleven Gotcha</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-twelve-revelations" title="Link target outside of Sample">Chapter Twelve Revelations</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-thirteen-life-goes-on" title="Link target outside of Sample">Chapter Thirteen Life Goes On</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-fourteen-tatiana" title="Link target outside of Sample">Chapter Fourteen Tatiana</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-fifteen-bad-news" title="Link target outside of Sample">Chapter Fifteen Bad News?</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-sixteen-monk" title="Link target outside of Sample">Chapter Sixteen Monk</span></li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-seventeen-choices-and-questions" title="Link target outside of Sample">Chapter Seventeen Choices and Questions</span></li>
<li id="toc-li-21"><span href="#/text/ch021#chapter-eighteen-no-hiding-place" title="Link target outside of Sample">Chapter Eighteen No Hiding Place</span></li>
<li id="toc-li-22"><span href="#/text/ch022#chapter-nineteen-end-game" title="Link target outside of Sample">Chapter Nineteen End Game</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?62387d62